import DatabaseSimpleForm from './DatabaseSimpleForm'

export default DatabaseSimpleForm
